var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTiff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-585 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(585 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.1,8.88h-.6V6A.422.422,0,0,0,51.5,5.95a.477.477,0,0,0-.115-.315L46.6.166l0,0a.479.479,0,0,0-.1-.081L46.463.063a.511.511,0,0,0-.1-.04L46.341.014A.493.493,0,0,0,46.229,0H34.465a.975.975,0,0,0-.974.974V8.88h-.6A1.391,1.391,0,0,0,31.5,10.271v7.236A1.392,1.392,0,0,0,32.9,18.9h.6v4.953a.975.975,0,0,0,.974.974H50.529a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.391-1.391V10.272A1.392,1.392,0,0,0,52.1,8.88ZM34.465.974H45.742V5.955a.487.487,0,0,0,.487.487h4.3V8.88H34.465ZM46.476,13.1v1.337h-2.61v2.923h-1.65V10.093H46.66v1.348H43.867V13.1h2.61Zm-5.684-3.009v7.27h-1.65v-7.27Zm-8.111,1.38v-1.38h5.587v1.38H36.284v5.889h-1.65V11.473ZM50.529,23.589H34.465V18.9H50.529v4.69Zm1.816-12.148H49.551V13.1h2.61v1.337h-2.61v2.923H47.9v-7.27h4.444v1.348Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiff);
export default __webpack_public_path__ + "static/media/tiff.e777d0ed540fa98ba4fc02471ae25d95.svg";
export { ForwardRef as ReactComponent };